export interface DashboardLayoutPanelState {
  isPanelMounted: (panelId: string) => boolean
  ensurePanel: (panelId: string) => boolean
}

let dashboardLayoutPanelState: DashboardLayoutPanelState | null = null

export function registerDashboardLayoutPanelState(state: DashboardLayoutPanelState): void {
  dashboardLayoutPanelState = state
}

export function unregisterDashboardLayoutPanelState(): void {
  dashboardLayoutPanelState = null
}

export function getDashboardLayoutPanelState(): DashboardLayoutPanelState | null {
  return dashboardLayoutPanelState
}
